const TicTacToeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={props.size || 48}
    height={props.size || 48}
    {...props}
  >
    {/* Background + plus shape */}
    <path
      fill="currentColor"
      d="M45,23H25V3c0-0.55-0.45-1-1-1s-1,0.45-1,1v20H3c-0.55,0-1,0.45-1,1s0.45,1,1,1h20v20c0,0.55,0.45,1,1,1
      s1-0.45,1-1V25h20c0.55,0,1-0.45,1-1S45.55,23,45,23z"
    />
    {/* X/O symbols*/}
    <path
      fill="currentColor"
      d="M35 27c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8S39.41 27 35 27zM35 41c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6S38.31 41 35 41zM20.71 27.29c-.39-.39-1.02-.39-1.41 0L13 33.59l-6.29-6.29c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L11.59 35l-6.29 6.29c-.39.39-.39 1.02 0 1.41C5.49 42.9 5.74 43 6 43s.51-.1.71-.29L13 36.41l6.29 6.29C19.49 42.9 19.74 43 20 43s.51-.1.71-.29c.39-.39.39-1.02 0-1.41L14.41 35l6.29-6.29C21.1 28.32 21.1 27.68 20.71 27.29zM13 5c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8S17.41 5 13 5zM13 19c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6S16.31 19 13 19zM36.41 13l6.29-6.29c.39-.39.39-1.02 0-1.41s-1.02-.39-1.41 0L35 11.59l-6.29-6.29c-.39-.39-1.02-.39-1.41 0s-.39 1.02 0 1.41L33.59 13l-6.29 6.29c-.39.39-.39 1.02 0 1.41C27.49 20.9 27.74 21 28 21s.51-.1.71-.29L35 14.41l6.29 6.29C41.49 20.9 41.74 21 42 21s.51-.1.71-.29c.39-.39.39-1.02 0-1.41L36.41 13z"
    />
  </svg>
);

export default TicTacToeIcon;
